/**
 * @generated SignedSource<<60a638fc30440ef677135c37a8947683>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type HighlightsPanel_DecisionsHighlight_decisions$data = ReadonlyArray<{
  readonly context: string | null;
  readonly text: string;
  readonly timestamp: number;
  readonly " $fragmentType": "HighlightsPanel_DecisionsHighlight_decisions";
}>;
export type HighlightsPanel_DecisionsHighlight_decisions$key = ReadonlyArray<{
  readonly " $data"?: HighlightsPanel_DecisionsHighlight_decisions$data;
  readonly " $fragmentSpreads": FragmentRefs<"HighlightsPanel_DecisionsHighlight_decisions">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "HighlightsPanel_DecisionsHighlight_decisions",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timestamp",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "context",
      "storageKey": null
    }
  ],
  "type": "TranscriptDecision",
  "abstractKey": null
};

(node as any).hash = "014c4cfe87961a42a6492de7ab1b133a";

export default node;
